import React from 'react';
import { Menu, Item, ItemParams } from 'react-contexify';
import {
  MESSAGE_CONTEXT_MENU_ID,
  MessageContextMenuItemProps,
} from '@/features/consults/chat/hooks/useMessageContextMenu';

interface MessageContextMenuProps {
  onReply: (message: any, ownerName: string) => void;
}

const MessageContextMenu = ({ onReply }: MessageContextMenuProps) => {
  const handleReplyClick = ({ props }: ItemParams<MessageContextMenuItemProps>) => {
    if (!props) return;
    onReply(props.message, props.ownerName);
  };

  return (
    <Menu
      id={MESSAGE_CONTEXT_MENU_ID}
      className="tw-rounded-5 tw-p-0 tw-shadow-lg tw-border tw-border-secondary-70/20 tw-overflow-hidden"
      style={
        {
          '--contexify-menu-minWidth': 'fit-content',
          '--contexify-activeItem-bgColor': '#106657',
        } as React.CSSProperties
      }
    >
      <Item onClick={handleReplyClick} className="tw-text-sm tw-text-primary-main">
        <svg
          className="tw-w-4 tw-h-4 tw-mr-2"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M9 17l-5-5 5-5M4 12h11a5 5 0 0 1 5 5v1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Trả lời
      </Item>
    </Menu>
  );
};

export default MessageContextMenu;
